/**
 * __mocks__/apiResponses/v2/clinicians.js
 * Autogenerated via generateMockRoute.js
 * DO NOT MODIFY THIS FILE STRUCTURE DIRECTLY.
 */

/** @type {import('../../mockRequestHandler').EndpointMockConfig} */
export default {
  "v2/clinicians/schedules": {
    active: true,
    GET: {
      active: true,
      default: {
        responseValues: {
          /* response: {
            isEmpty: true,
          }, */
          response: [
            {
              clinician_id: "145163",
              clinician_name: "Kylee Danford",
              current_case_load: 3,
              client_schedules: [
                {
                  client_id: "123456",
                  client_name: "Rita Lopez",
                  eventsData: [
                    {
                      client_user_id: "144873",
                      client_id: "144111",
                      clinician_user_id: "21715",
                      room_id: null,
                      start_date: null,
                      end_date: null,
                      scheduled_date: "2025-04-25T19:00:00.000Z",
                      user_guid: null,
                      vyte_id: null,
                      start_signature_url: null,
                      end_signature_url: null,
                      end_bcba_signature_url: null,
                      start_bcba_signature_url: null,
                      call_type: "Assessment",
                      actual_time: null,
                      billable_units: null,
                      video_key: "cm78hf79m00051vjodzrz4tp6",
                      is_test: false,
                      needs_notes: true,
                      off_platform: false,
                      no_show: false,
                      call_duration: 60,
                      secondary_clinician_user_id: null,
                      legacy_notes: false,
                      billing_type: "DIRECT_THERAPY",
                      healthie_video_call_id: null,
                      call_timezone: "America/New_York",
                      is_recurring: true,
                      parent_video_call_id: "51117",
                      start_time: null,
                      begin_date: null,
                      stop_date: null,
                      stop_type: null,
                      canceled: false,
                      rescheduled: true,
                      video_chat_url:
                        "sendbird_group_channel_200229676_cbd6ab42fa248323ceebc13c16160462e62a5a57",
                      call_instructions: null,
                      repeat_days: "1,3,5",
                      repeat_type: "until_date",
                      repeat_weeks: null,
                      repeat_until_date: "2025-05-28T05:00:00.000Z",
                      cancel_reason: null,
                      off_platform_type: null,
                      not_started: false,
                      responsible_for_cancellation: null,
                      cancel_date: null,
                      removed: false,
                      healthie_scheduled: false,
                      created_date: "2025-02-17T03:14:38.861Z",
                      description: null,
                      time_interval: 1,
                      time_unit: "weeks",
                      billable_time_id: null,
                      is_tentative: false,
                      master_call_instructions: null,
                      parent_name: "Blank Page",
                      clinician_name: "Jenika Karnik",
                      name: "Kiddo",
                      child_last_name: "Page",
                      client_timezone: "America/New_York",
                      chat_conversation_id: 187222,
                      is_video_call: true,
                    },
                    {
                      client_user_id: "144873",
                      client_id: "144111",
                      clinician_user_id: "21715",
                      room_id: null,
                      start_date: null,
                      end_date: null,
                      scheduled_date: "2025-03-25T22:00:00.000Z",
                      user_guid: null,
                      vyte_id: null,
                      start_signature_url: null,
                      end_signature_url: null,
                      end_bcba_signature_url: null,
                      start_bcba_signature_url: null,
                      call_type: "Assessment",
                      actual_time: null,
                      billable_units: null,
                      video_key: "cm78hf79m00051vjodzrz4tp6",
                      is_test: false,
                      needs_notes: true,
                      off_platform: false,
                      no_show: false,
                      call_duration: 60,
                      secondary_clinician_user_id: null,
                      legacy_notes: false,
                      billing_type: "CAREGIVER_TRAINING",
                      healthie_video_call_id: null,
                      call_timezone: "America/New_York",
                      is_recurring: true,
                      parent_video_call_id: "51117",
                      start_time: null,
                      begin_date: null,
                      stop_date: null,
                      stop_type: null,
                      canceled: false,
                      rescheduled: true,
                      video_chat_url:
                        "sendbird_group_channel_200229676_cbd6ab42fa248323ceebc13c16160462e62a5a57",
                      call_instructions: null,
                      repeat_days: "0,3",
                      repeat_type: "until_date",
                      repeat_weeks: null,
                      repeat_until_date: "2025-04-28T05:00:00.000Z",
                      cancel_reason: null,
                      off_platform_type: null,
                      not_started: false,
                      responsible_for_cancellation: null,
                      cancel_date: null,
                      removed: false,
                      healthie_scheduled: false,
                      created_date: "2025-02-17T03:14:38.861Z",
                      description: null,
                      time_interval: 1,
                      time_unit: "weeks",
                      billable_time_id: null,
                      is_tentative: false,
                      master_call_instructions: null,
                      parent_name: "Blank Page",
                      clinician_name: "Jenika Karnik",
                      name: "Kiddo",
                      child_last_name: "Page",
                      client_timezone: "America/New_York",
                      chat_conversation_id: 187222,
                      is_video_call: true,
                    },
                  ],
                },
                {
                  client_id: "123456",
                  client_name: "Arnold Lopez",
                  eventsData: [
                    {
                      client_user_id: "144873",
                      client_id: "144111",
                      clinician_user_id: "21715",
                      room_id: null,
                      start_date: null,
                      end_date: null,
                      scheduled_date: "2025-03-05T22:00:00.000Z",
                      user_guid: null,
                      vyte_id: null,
                      start_signature_url: null,
                      end_signature_url: null,
                      end_bcba_signature_url: null,
                      start_bcba_signature_url: null,
                      call_type: "Assessment",
                      actual_time: null,
                      billable_units: null,
                      video_key: "cm78hf79m00051vjodzrz4tp6",
                      is_test: false,
                      needs_notes: true,
                      off_platform: false,
                      no_show: false,
                      call_duration: 60,
                      secondary_clinician_user_id: null,
                      legacy_notes: false,
                      billing_type: "CAREGIVER_TRAINING",
                      healthie_video_call_id: null,
                      call_timezone: "America/New_York",
                      is_recurring: true,
                      parent_video_call_id: "51117",
                      start_time: null,
                      begin_date: null,
                      stop_date: null,
                      stop_type: null,
                      canceled: false,
                      rescheduled: true,
                      video_chat_url:
                        "sendbird_group_channel_200229676_cbd6ab42fa248323ceebc13c16160462e62a5a57",
                      call_instructions: null,
                      repeat_days: "0,3",
                      repeat_type: "until_date",
                      repeat_weeks: null,
                      repeat_until_date: "2025-04-28T05:00:00.000Z",
                      cancel_reason: null,
                      off_platform_type: null,
                      not_started: false,
                      responsible_for_cancellation: null,
                      cancel_date: null,
                      removed: false,
                      healthie_scheduled: false,
                      created_date: "2025-02-17T03:14:38.861Z",
                      description: null,
                      time_interval: 1,
                      time_unit: "weeks",
                      billable_time_id: null,
                      is_tentative: false,
                      master_call_instructions: null,
                      parent_name: "Blank Page",
                      clinician_name: "Jenika Karnik",
                      name: "Kiddo",
                      child_last_name: "Page",
                      client_timezone: "America/New_York",
                      chat_conversation_id: 187222,
                      is_video_call: true,
                    },
                  ],
                },
              ],
            },
            {
              clinician_id: "145164",
              clinician_name: "Jenika Karnik",
              current_case_load: 3,
              client_schedules: [
                {
                  client_id: "123459",
                  client_name: "Arnold Lopez",
                  eventsData: [
                    {
                      client_user_id: "144873",
                      client_id: "144111",
                      clinician_user_id: "21715",
                      room_id: null,
                      start_date: null,
                      end_date: null,
                      scheduled_date: "2025-03-05T22:00:00.000Z",
                      user_guid: null,
                      vyte_id: null,
                      start_signature_url: null,
                      end_signature_url: null,
                      end_bcba_signature_url: null,
                      start_bcba_signature_url: null,
                      call_type: "Assessment",
                      actual_time: null,
                      billable_units: null,
                      video_key: "cm78hf79m00051vjodzrz4tp6",
                      is_test: false,
                      needs_notes: true,
                      off_platform: false,
                      no_show: false,
                      call_duration: 60,
                      secondary_clinician_user_id: null,
                      legacy_notes: false,
                      billing_type: "CAREGIVER_TRAINING",
                      healthie_video_call_id: null,
                      call_timezone: "America/New_York",
                      is_recurring: true,
                      parent_video_call_id: "51117",
                      start_time: null,
                      begin_date: null,
                      stop_date: null,
                      stop_type: null,
                      canceled: false,
                      rescheduled: true,
                      video_chat_url:
                        "sendbird_group_channel_200229676_cbd6ab42fa248323ceebc13c16160462e62a5a57",
                      call_instructions: null,
                      repeat_days: "0,3",
                      repeat_type: "until_date",
                      repeat_weeks: null,
                      repeat_until_date: "2025-04-28T05:00:00.000Z",
                      cancel_reason: null,
                      off_platform_type: null,
                      not_started: false,
                      responsible_for_cancellation: null,
                      cancel_date: null,
                      removed: false,
                      healthie_scheduled: false,
                      created_date: "2025-02-17T03:14:38.861Z",
                      description: null,
                      time_interval: 1,
                      time_unit: "weeks",
                      billable_time_id: null,
                      is_tentative: false,
                      master_call_instructions: null,
                      parent_name: "Blank Page",
                      clinician_name: "Jenika Karnik",
                      name: "Kiddo",
                      child_last_name: "Page",
                      client_timezone: "America/New_York",
                      chat_conversation_id: 187222,
                      is_video_call: true,
                    },
                  ],
                },
              ],
            },
          ],
          status: 204,
        },
      },
      scenarios: {},
    },
    POST: {
      active: false,
      default: {
        responseValues: {
          response: null,
          status: 204,
        },
      },
      scenarios: {},
    },
    PUT: {
      active: false,
      default: {
        responseValues: {
          response: null,
          status: 204,
        },
      },
      scenarios: {},
    },
    DELETE: {
      active: false,
      default: {
        responseValues: {
          response: null,
          status: 204,
        },
      },
      scenarios: {},
    },
  },
};
